var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutmeImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-14",
    cx: 249.86,
    cy: 362.36,
    rx: 224.23,
    ry: 124.15,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-14",
    d: "M451.69,343.15l-125,72.2a3.69,3.69,0,0,1-3.36,0l-180.22-104a1,1,0,0,1,0-1.94l125-72.2a3.69,3.69,0,0,1,3.36,0l180.22,104A1,1,0,0,1,451.69,343.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-14",
    cx: 161.23,
    cy: 412.39,
    rx: 75.08,
    ry: 43.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-14",
    cx: 252.65,
    cy: 362.13,
    rx: 59.1,
    ry: 34.12,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-14",
    cx: 384.09,
    cy: 407.87,
    rx: 37.1,
    ry: 21.42,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.42,286.36v111a2.48,2.48,0,0,1-1.12,1.94l-2.38,1.37a2.46,2.46,0,0,1-2.24,0l-2.38-1.37a2.48,2.48,0,0,1-1.12-1.94V286.36c0-.71.5-1,1.12-.64l2.38,1.37a2.46,2.46,0,0,0,2.24,0l2.38-1.37C328.92,285.36,329.42,285.65,329.42,286.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,400.62l-2.38-1.37a2.48,2.48,0,0,1-1.12-1.94V286.36c0-.71.5-1,1.12-.64l2.38,1.37A2.48,2.48,0,0,1,324.8,289V400C324.8,400.69,324.3,401,323.68,400.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.93,227.72V338.66a2.45,2.45,0,0,1-1.12,1.94L427.43,342a2.52,2.52,0,0,1-2.24,0l-2.38-1.38a2.48,2.48,0,0,1-1.12-1.94V227.72c0-.71.51-1,1.12-.65l2.38,1.38a2.46,2.46,0,0,0,2.24,0l2.38-1.38C430.43,226.72,430.93,227,430.93,227.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,342l-2.38-1.38a2.48,2.48,0,0,1-1.12-1.94V227.72c0-.71.51-1,1.12-.65l2.38,1.38a2.47,2.47,0,0,1,1.12,1.94V341.33C426.31,342,425.81,342.33,425.19,342Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.71,207.47v111a2.48,2.48,0,0,1-1.12,1.94l-2.38,1.37a2.46,2.46,0,0,1-2.24,0l-2.38-1.37a2.48,2.48,0,0,1-1.12-1.94v-111c0-.71.5-1,1.12-.64L187,208.2a2.46,2.46,0,0,0,2.24,0l2.38-1.37C192.21,206.47,192.71,206.76,192.71,207.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,321.73l-2.38-1.37a2.48,2.48,0,0,1-1.12-1.94v-111c0-.71.5-1,1.12-.64L187,208.2a2.48,2.48,0,0,1,1.12,1.94V321.08C188.09,321.8,187.59,322.09,187,321.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,235.61v-.81a4.49,4.49,0,0,0-2-3.53L272,128a4.51,4.51,0,0,0-4.08,0l-110.12,63.6a4.49,4.49,0,0,0-2,3.53V196a4.49,4.49,0,0,0,2,3.53l179,103.26a4.58,4.58,0,0,0,4.08,0L451,239.14A4.49,4.49,0,0,0,453,235.61Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,235.61v-.81a4.49,4.49,0,0,0-2-3.53L272,128a4.51,4.51,0,0,0-4.08,0l-110.12,63.6a4.49,4.49,0,0,0-2,3.53V196a4.49,4.49,0,0,0,2,3.53l179,103.26a4.58,4.58,0,0,0,4.08,0L451,239.14A4.49,4.49,0,0,0,453,235.61Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,297.72v5.52a4.24,4.24,0,0,0,2-.49L451,239.15a4.51,4.51,0,0,0,2-3.53v-.82a4.53,4.53,0,0,0-1.66-3.26c.73.63.61,1.5-.38,2.09l-110.12,63.6A4.13,4.13,0,0,1,338.82,297.72Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,297.72v5.52a4.24,4.24,0,0,0,2-.49L451,239.15a4.51,4.51,0,0,0,2-3.53v-.82a4.53,4.53,0,0,0-1.66-3.26c.73.63.61,1.5-.38,2.09l-110.12,63.6A4.13,4.13,0,0,1,338.82,297.72Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,233.62,340.86,297.23a4.51,4.51,0,0,1-4.08,0L157.77,194a1.24,1.24,0,0,1,0-2.35L267.89,128a4.51,4.51,0,0,1,4.08,0L451,231.27A1.24,1.24,0,0,1,451,233.62Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,233.62,340.86,297.23a4.51,4.51,0,0,1-4.08,0L157.77,194a1.24,1.24,0,0,1,0-2.35L267.89,128a4.51,4.51,0,0,1,4.08,0L451,231.27A1.24,1.24,0,0,1,451,233.62Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M325.29,232.24l-26.09,15.1a3.25,3.25,0,0,1-2.93,0L219.19,202.9a.89.89,0,0,1,0-1.69l26.09-15.11a3.26,3.26,0,0,1,2.92,0l77.09,44.45A.89.89,0,0,1,325.29,232.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.77,198.53a1,1,0,0,1,.61-.84l24.51-14.15a3.2,3.2,0,0,1,2.92,0l74.8,43.25a1,1,0,0,1,.6.85v2.57a1,1,0,0,1-.6.84l-24.5,14.15a3.22,3.22,0,0,1-2.93,0L221.38,202a1,1,0,0,1-.61-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,242.57l24.5-14.09a.89.89,0,0,0,0-1.69l-74.8-43.25a3.2,3.2,0,0,0-2.92,0l-24.51,14.15a.89.89,0,0,0,0,1.69l74.8,43.18A3.25,3.25,0,0,0,299.11,242.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,242.91v2.63a2.92,2.92,0,0,0,1.37-.34l24.49-14.14a1,1,0,0,0,.61-.85v-2.58a1,1,0,0,1-.61.85l-24.49,14.09A3,3,0,0,1,297.74,242.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31,198.72s0,0,0,0l2.42-1.4,3.29,1.9-2.44,1.45-3.29-1.9Zm3.8-2.19a0,0,0,0,1,0,0l2.43-1.4,2.59,1.49L231.69,198l-2.58-1.49Zm.8,4.85a0,0,0,0,1,0,0l2.43-1.4,2.58,1.49-2.44,1.45-2.58-1.49Zm3-7s0,0,0,0l2.43-1.4,4.17,2.42-2.44,1.44-4.17-2.41Zm.09,4.44s0,0,0,0l2.42-1.41,2.06,1.19L235.05,200,233,198.79Zm.8,4.84,0,0,2.42-1.4,2.59,1.49-2.45,1.45-2.58-1.49Zm2.56-2.9a.05.05,0,0,1,0,0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.34-8.58,0,0,2.43-1.4,3.29,1.9L240,194.06l-3.29-1.9Zm1,13.73s0,0,0,0l2.42-1.4,18.68,10.78-2.44,1.45-18.68-10.78Zm.7-8.37s0,0,0,0l2.42-1.4,2,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19-2.44,1.45-2.05-1.19ZM240.5,190s0,0,0,0l2.42-1.4,2.06,1.19-2.44,1.44L240.51,190Zm.8,4.85s0,0,0,0l2.42-1.4,2.06,1.18L243.36,196l-2.06-1.18Zm.45,4.64s0,0,0,0l2.42-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16a.05.05,0,0,1,0,0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.78-12.71s0,0,0,0l2.42-1.4,2.06,1.19-2.44,1.44-2-1.18Zm.8,4.85s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.45,4.64,0,0,2.42-1.4,2,1.19-2.44,1.44-2-1.18Zm0-14.09s0,0,0,0l2.42-1.4,2.59,1.49-2.45,1.45-2.58-1.49Zm1.33,19.25a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.78-12.71s0,0,0,0l2.42-1.4,2.06,1.19L249.28,195l-2.05-1.18Zm.8,4.85s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45L248,198.7Zm.45,4.64s0,0,0,0l2.42-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16a.05.05,0,0,1,0,0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.66-18.1s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.12,5.39s0,0,0,0l2.42-1.4,2.06,1.19L252.63,197l-2-1.18Zm.8,4.85s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.45,4.64s0,0,0,0l2.42-1.4,2,1.19-2.44,1.44-2-1.18Zm1.33,5.16s0,0,0,0L255.6,209l2,1.19-2.44,1.45-2.05-1.19Zm.66-18.1s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm.12,5.39s0,0,0,0l2.42-1.4,2.06,1.19L256,198.91l-2-1.18Zm.8,4.85s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.45,4.64v0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16s0,0,0,0l2.42-1.41,2.05,1.19-2.44,1.45-2.05-1.19Zm.66-18.1s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.12,5.39s0,0,0,0l2.43-1.4,2.05,1.19-2.45,1.44-2-1.18Zm.37,17.76a0,0,0,0,1,0,0l2.43-1.4,2.58,1.49-2.44,1.45-2.58-1.49Zm.43-12.91s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.45,4.64v0l2.43-1.4L263,208.9l-2.44,1.44-2.05-1.18Zm1.33,5.16a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm.66-18.1s0,0,0,0l2.43-1.4L265,196l-2.44,1.45-2.05-1.18Zm.12,5.39s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.8,4.85s0,0,0,0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm.1,13.21s0,0,0,0l2.43-1.4,2.58,1.49-2.44,1.45-2.58-1.49Zm.35-8.57s0,0,0,0l2.42-1.4,2,1.19L264,212.28l-2-1.18Zm1.33,5.16a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm.78-12.71s0,0,0,0l2.43-1.4,2,1.19-2.44,1.44L264,203.55Zm.8,4.85s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.45,4.64s0,0,0,0l2.42-1.4,2.05,1.19-2.44,1.44L265.27,213Zm.1-14s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.45L265.37,199Zm.08,22.91a0,0,0,0,1,0,0l2.43-1.4,2.58,1.49L268,223.41l-2.58-1.49Zm1.15-3.72s0,0,0,0l2.42-1.41,2.06,1.19-2.45,1.45-2-1.19Zm.78-12.71a0,0,0,0,1,0,0l2.42-1.4,2.06,1.19-2.44,1.44-2.05-1.18Zm.8,4.85s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.45,4.64s0,0,0,0l2.42-1.4,2.06,1.19-2.45,1.44L268.63,215Zm.1-14s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.45-2-1.19Zm.62,23.22a0,0,0,0,1,0,0l2.43-1.41,3.29,1.9-2.44,1.45-3.29-1.9Zm.61-4s0,0,0,0l2.42-1.41,6.48,3.74-2.44,1.45L270,220.13Zm.78-12.71s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.8,4.85s0,0,0,0l2.43-1.4L276,212l-2.44,1.45-2.05-1.18Zm.45,4.64s0,0,0,0l2.42-1.4,2.06,1.19L274,218.1,272,216.92Zm.1-14s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm2,6.48s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.55,17.86s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.25-13s0,0,0,0l2.43-1.4,2,1.18L277,215.4l-2-1.18Zm.45,4.64,0,0,2.42-1.4,1.88,1.08a1.2,1.2,0,0,0,.59.13,1.33,1.33,0,0,0,.62-.13l3.19-1.84,2.4,1.39-6.23,3.64-4.89-2.82Zm.1-14s0,0,0,0l2.43-1.4,2.05,1.19L277.5,206l-2.05-1.19Zm2,6.48s0,0,0,0l2.42-1.4,2.06,1.19-2.44,1.44-2-1.18Zm.55,17.86s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.25-13s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm2-8.55s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2.05-1.18Zm.55,5.64s0,0,0,0l2.42-1.4,2.06,1.19-2.44,1.44-2.05-1.18Zm.55,17.86s0,0,0,0l2.43-1.4,2.05,1.18-2.45,1.45-2-1.18Zm.44-4.13a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.45,1.45L281.81,227Zm1.82-17.43s0,0,0,0l2.42-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.55,5.64s0,0,0,0l2.43-1.4,3.64,2.1-2.44,1.45-3.64-2.1Zm1.26,18.27s0,0,0,0l2.42-1.4,5.42,3.12-2.45,1.45-5.41-3.12Zm.6-12.81,0,0,2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.95-9.16s0,0,0,0l2.42-1.4,2.05,1.18L289,212.67,287,211.49Zm2.25,19.78s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.16-8.68,0,0,2.43-1.4,2,1.19-2.44,1.44-2-1.18Zm.44-4.13s0,0,0,0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm.51-5s0,0,0,0l2.42-1.4,2,1.18-2.44,1.45-2-1.18Zm1.81,23.91s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.44-4.13s0,0,0,0l2.43-1.4,2,1.19-2.44,1.45-2-1.19Zm.16-8.68,0,0,2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.28,4.54a.1.1,0,0,1,0,0l2.43-1.4,2,1.19-2.44,1.44-2-1.18Zm.16-8.67s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm1.25-4.6s0,0,0,0l2.42-1.4,2.06,1.18L296.51,217l-2.05-1.18Zm1.07,23.48s0,0,0,0l6.22-3.6,2.05,1.19-6.23,3.64-2.06-1.18Zm.44-4.13s0,0,0,0l2.43-1.4,2.05,1.19L298,236.33,296,235.14Zm.44-4.14a.1.1,0,0,1,0,0l2.43-1.4,2.05,1.19-2.44,1.44L296.4,231Zm.16-8.67s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.27,4.54s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm1-9.14s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm1.95,15.21a.1.1,0,0,1,0,0l2.43-1.4,2.05,1.19-2.44,1.45L299.76,233Zm.43-4.13s0,0,0,0l2.43-1.4,2.05,1.18L302.25,230l-2.05-1.18Zm.44-4.13s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.54-5s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm1.95,15.21v0l6.23-3.59,2.05,1.18-6.24,3.65-2.05-1.19Zm.43-4.13s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.44-4.13s0,0,0,0l2.42-1.4,2.06,1.18L306,227.81l-2-1.18Zm2.23-5.17v0l1-.61,2.06,1.19-1.06.65-2-1.18Zm1.13,7.11s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm2.23-5.17s0,0,0,0l1-.61,2.06,1.19-1.06.65-2-1.18Zm1.13,7.11s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm2.23-5.17s0,0,0,0l1-.61,2.06,1.19-1.06.65-2-1.18Zm3.35,1.94s0,0,0,0l1-.61,2.06,1.19-1.06.65-2-1.18Z",
    style: {
      fill: "#8C6F6F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-14",
    points: "385.58 235.17 408.53 221.92 293.77 155.66 270.82 168.91 385.58 235.17",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.59,213.6l-16.38-9.48c-1.69-1-2.54-2.25-2.54-3.53v-2.28l15.42-8.75a3.62,3.62,0,0,0,1.63-2.83v-20.2l28.62,16.54v20.2a3.62,3.62,0,0,1-1.63,2.83l-12.88,7.5A13.54,13.54,0,0,1,320.59,213.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.47,206.85v2.27l5.24-3a3.6,3.6,0,0,0,1.63-2.83v-20.2l-5.45-3.15c-.11,1.39-.24,2.82-.35,4.21l3.82,2.22v15.78a3.57,3.57,0,0,1-1.63,2.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.36,202.13a3.6,3.6,0,0,1-1.63,2.83l-10.9,6.36a13.54,13.54,0,0,1-12.24,0l-16.39-9.48c-3.38-1.94-3.38-5.11,0-7.06l10.91-6.36a3.6,3.6,0,0,0,1.63-2.82V169.81l28.62,16.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.79,190.34h0l3.32-1.92a3.6,3.6,0,0,0,1.63-2.82V169.81l28.62,16.54v15.78a3.6,3.6,0,0,1-1.63,2.83l-3.26,1.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.67,198.31v2.28c0,1.28.85,2.55,2.53,3.53l16.39,9.47a12.32,12.32,0,0,0,5.84,1.45v-2.27a12.32,12.32,0,0,1-5.84-1.45l-16.39-9.48C302.52,200.87,301.67,199.59,301.67,198.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.32,223.93a4.37,4.37,0,0,1-3.95-.07L276.68,160a4.49,4.49,0,0,1-2-3.53V59.54a3.83,3.83,0,0,1,5.87-3.39l110.68,63.91a4.49,4.49,0,0,1,2,3.53v96.88A4.36,4.36,0,0,1,391.32,223.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.37,223.85,276.68,160a4.49,4.49,0,0,1-2-3.53V59.53c0-1.3.91-1.82,2-1.17l110.69,63.9a4.52,4.52,0,0,1,2,3.53v96.89C389.41,224,388.49,224.5,387.37,223.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,224.26a3.81,3.81,0,0,0,5.56-3.54v-10.9L389.41,212v10.9C389.41,224.12,388.66,224.65,387.67,224.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.41,212v10.9c0,1.3-.92,1.83-2,1.18L276.68,160.2a4.49,4.49,0,0,1-2-3.53v-10.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.58,203.74V127.06a2.72,2.72,0,0,0-1.22-2.12L279.69,64.52c-.67-.39-1.22-.08-1.22.7V141.9a2.69,2.69,0,0,0,1.22,2.12l104.67,60.43C385,204.84,385.58,204.52,385.58,203.74Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.58,203.74V127.06a2.72,2.72,0,0,0-1.22-2.12L279.69,64.52c-.67-.39-1.22-.08-1.22.7V141.9a2.69,2.69,0,0,0,1.22,2.12l104.67,60.43C385,204.84,385.58,204.52,385.58,203.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,183.07a4.24,4.24,0,0,1,1.91,3.31c0,1.22-.86,1.72-1.91,1.11a4.24,4.24,0,0,1-1.92-3.32C330.11,183,331,182.46,332,183.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.81,123.78a4.4,4.4,0,0,1,.6,2V212l3.82-2.21V123.59a4.2,4.2,0,0,0-.6-2Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.75,39.53a1.13,1.13,0,0,1,0-.18.08.08,0,0,1,0,0,.84.84,0,0,1,0-.17.8.8,0,0,1,.11-.25.33.33,0,0,1,.06-.1l.06-.07a.8.8,0,0,1,.13-.13h0a1,1,0,0,1,.17-.1,1.43,1.43,0,0,1,1.31.17l129.18,74.54a4.35,4.35,0,0,1,1.95,3.39v93.49h0v.43a1.33,1.33,0,0,1-.7,1.17l-.09.06-.1.06-.17,0a1,1,0,0,1-.25,0,1.29,1.29,0,0,1-.64-.19l-.05,0h0L422,210.6,294.69,137.12a4.32,4.32,0,0,1-1.95-3.38v-94C292.74,39.69,292.75,39.61,292.75,39.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.38,38.48a1.43,1.43,0,0,1,1.31.17l129.18,74.54a4.35,4.35,0,0,1,1.95,3.39V123l2.49-1.46v-6.33a4.32,4.32,0,0,0-1.95-3.38L297.18,37.24a1.36,1.36,0,0,0-1.41-.12C295.42,37.34,293.8,38.26,293.38,38.48Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74,39.76c0-1.23.88-1.73,1.95-1.11L423.87,113.2a4.29,4.29,0,0,1,1.95,3.38V123L292.74,46.17Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.69,38.65,423.87,113.2a4,4,0,0,1,1.37,1.44l2.48-1.43a3.91,3.91,0,0,0-1.36-1.43L297.19,37.24a1.38,1.38,0,0,0-1.42-.12c-.35.22-2,1.14-2.38,1.36A1.38,1.38,0,0,1,294.69,38.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.32,121.5v-6.34a4,4,0,0,0-.59-2l-2.49,1.43a3.84,3.84,0,0,1,.59,1.94V123Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.42,114.54a2.91,2.91,0,0,1,1.1,2.34c0,.93-.49,1.41-1.1,1.06a2.91,2.91,0,0,1-1.1-2.34C420.32,114.67,420.81,114.19,421.42,114.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.45,112.25a2.89,2.89,0,0,1,1.1,2.33c0,.94-.49,1.41-1.1,1.06a2.89,2.89,0,0,1-1.1-2.33C416.35,112.37,416.84,111.9,417.45,112.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.48,110a2.91,2.91,0,0,1,1.1,2.34c0,.93-.49,1.41-1.1,1.06a2.92,2.92,0,0,1-1.1-2.34C412.38,110.07,412.87,109.6,413.48,110Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.12,211.69l.1-.06,2.06-1.19a2.06,2.06,0,0,0,1-1.51,2.64,2.64,0,0,0,0-.28V121.49l-2.5,1.47v87.55a1.29,1.29,0,0,1-.61,1.11l-.06,0h0Z",
    style: {
      fill: "#263238",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.31,79.44l27.23,15.69a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.58-.7.35L332.31,80.94a1.49,1.49,0,0,1-.69-1.15C331.62,79.37,331.93,79.22,332.31,79.44Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,109.48,353,115.42a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35L342.72,111a1.46,1.46,0,0,1-.7-1.15C342,109.42,342.33,109.26,342.72,109.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,115.49,353,121.42a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L342.72,117a1.48,1.48,0,0,1-.7-1.15C342,115.42,342.33,115.27,342.72,115.49Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,96.68l54.53,31.4a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-54.53-31.4a1.51,1.51,0,0,1-.69-1.16C361.54,96.62,361.85,96.46,362.23,96.68Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,151.61l16.6,9.61a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-16.6-9.61a1.48,1.48,0,0,1-.69-1.15C342.25,151.55,342.56,151.39,342.94,151.61Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,162.77l54.53,31.44a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-54.53-31.44a1.49,1.49,0,0,1-.69-1.15C361.54,162.7,361.85,162.55,362.23,162.77Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,85.46,346,93.34a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35L332.31,87a1.48,1.48,0,0,1-.69-1.15C331.62,85.4,331.93,85.24,332.31,85.46Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,85.46,346,93.34a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35L332.31,87a1.48,1.48,0,0,1-.69-1.15C331.62,85.4,331.93,85.24,332.31,85.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,91.46l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.41-.31.57-.69.35L332.31,93a1.49,1.49,0,0,1-.69-1.15C331.62,91.39,331.93,91.24,332.31,91.46Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,91.46l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.41-.31.57-.69.35L332.31,93a1.49,1.49,0,0,1-.69-1.15C331.62,91.39,331.93,91.24,332.31,91.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,103.47l6.42,3.7a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-6.42-3.7a1.51,1.51,0,0,1-.69-1.16C331.62,103.41,331.93,103.25,332.31,103.47Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,103.47l6.42,3.7a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-6.42-3.7a1.51,1.51,0,0,1-.69-1.16C331.62,103.41,331.93,103.25,332.31,103.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,109.48l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.69-1.15C331.62,109.42,331.93,109.26,332.31,109.48Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,109.48l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.69-1.15C331.62,109.42,331.93,109.26,332.31,109.48Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,94.89l8.22,4.77a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-8.22-4.76a1.5,1.5,0,0,1-.7-1.16C348,94.83,348.33,94.67,348.72,94.89Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,94.89l8.22,4.77a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-8.22-4.76a1.5,1.5,0,0,1-.7-1.16C348,94.83,348.33,94.67,348.72,94.89Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,138.33l55.32,31.85a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-55.32-31.85a1.48,1.48,0,0,1-.7-1.15C360.74,138.26,361.05,138.11,361.44,138.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.53,159.4l8.23,4.76a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.23-4.76a1.49,1.49,0,0,1-.69-1.15C407.84,159.33,408.15,159.17,408.53,159.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.52,126l55.32,31.85a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L350.52,127.5a1.5,1.5,0,0,1-.69-1.16C349.83,125.93,350.14,125.77,350.52,126Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,97.47l13.71,7.88a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L342.72,99a1.48,1.48,0,0,1-.7-1.15C342,97.4,342.33,97.24,342.72,97.47Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,97.47l13.71,7.88a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L342.72,99a1.48,1.48,0,0,1-.7-1.15C342,97.4,342.33,97.24,342.72,97.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.12,106.9,416.35,140a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L359.12,108.4a1.49,1.49,0,0,1-.69-1.15C358.43,106.83,358.74,106.68,359.12,106.9Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.12,106.9,416.35,140a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L359.12,108.4a1.49,1.49,0,0,1-.69-1.15C358.43,106.83,358.74,106.68,359.12,106.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,133.64l74,42.69a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-74-42.7A1.48,1.48,0,0,1,342,134C342,133.57,342.33,133.42,342.72,133.64Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,127.63l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.69-1.15C331.62,127.57,331.93,127.41,332.31,127.63Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,127.63l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.69-1.15C331.62,127.57,331.93,127.41,332.31,127.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,139.64l74,42.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-74-42.7A1.46,1.46,0,0,1,342,140C342,139.58,342.33,139.42,342.72,139.64Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,133.64l6.42,3.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.49,1.49,0,0,1-.69-1.15C331.62,133.57,331.93,133.42,332.31,133.64Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,133.64l6.42,3.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.49,1.49,0,0,1-.69-1.15C331.62,133.57,331.93,133.42,332.31,133.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,145.65l74,42.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-74-42.7A1.48,1.48,0,0,1,342,146C342,145.58,342.33,145.43,342.72,145.65Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,139.64l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-6.42-3.71a1.48,1.48,0,0,1-.69-1.15C331.62,139.58,331.93,139.42,332.31,139.64Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,139.64l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-6.42-3.71a1.48,1.48,0,0,1-.69-1.15C331.62,139.58,331.93,139.42,332.31,139.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.31,73.41l3.77,2.18a1.51,1.51,0,0,1,.68,1.19v1.39c0,.43-.3.61-.68.39l-3.77-2.18a1.5,1.5,0,0,1-.69-1.18V73.81C321.62,73.37,321.93,73.2,322.31,73.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,79.48l3.77,2.18a1.51,1.51,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19V79.87C321.62,79.44,321.93,79.26,322.31,79.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,85.54l3.77,2.18a1.51,1.51,0,0,1,.68,1.19V90.3c0,.43-.3.61-.68.39l-3.77-2.18a1.52,1.52,0,0,1-.69-1.18V85.94C321.62,85.5,321.93,85.33,322.31,85.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,91.61l3.77,2.18a1.51,1.51,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19V92C321.62,91.57,321.93,91.39,322.31,91.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,97.67l3.77,2.18a1.51,1.51,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.18V98.07C321.62,97.63,321.93,97.45,322.31,97.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,103.74l3.77,2.18a1.49,1.49,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,103.7,321.93,103.52,322.31,103.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,109.8l3.77,2.18a1.51,1.51,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.18V110.2C321.62,109.76,321.93,109.58,322.31,109.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,115.87l3.77,2.18a1.49,1.49,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.39l-3.77-2.17a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,115.83,321.93,115.65,322.31,115.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,121.93l3.77,2.18a1.51,1.51,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19v-1.38C321.62,121.89,321.93,121.71,322.31,121.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,128l3.77,2.18a1.48,1.48,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.39L322.31,131a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,128,321.93,127.78,322.31,128Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,134.06l3.77,2.18a1.51,1.51,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4L322.31,137a1.52,1.52,0,0,1-.69-1.19v-1.38C321.62,134,321.93,133.84,322.31,134.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,140.13l3.77,2.17a1.51,1.51,0,0,1,.68,1.19v1.39c0,.44-.3.61-.68.39l-3.77-2.17a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,140.09,321.93,139.91,322.31,140.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.28,53.71l20.4,11.78a3,3,0,0,1,1.37,2.37V91.42c0,.87-.61,1.23-1.37.79l-20.4-11.78a3,3,0,0,1-1.37-2.37V54.51C295.91,53.63,296.52,53.28,297.28,53.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,77.06l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C298.48,77,298.79,76.84,299.17,77.06Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,77.06l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C298.48,77,298.79,76.84,299.17,77.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,57.77l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C298.48,57.71,298.79,57.55,299.17,57.77Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,57.77l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C298.48,57.71,298.79,57.55,299.17,57.77Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,63.15l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,63.08,301.43,62.93,301.81,63.15Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,63.15l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,63.08,301.43,62.93,301.81,63.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,67l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,66.93,301.43,66.77,301.81,67Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,67l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,66.93,301.43,66.77,301.81,67Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,69.34l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.5,1.5,0,0,1-.69-1.16C298.48,69.28,298.79,69.12,299.17,69.34Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,69.34l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.5,1.5,0,0,1-.69-1.16C298.48,69.28,298.79,69.12,299.17,69.34Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,74.72l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,74.66,301.43,74.5,301.81,74.72Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,74.72l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,74.66,301.43,74.5,301.81,74.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,60.74l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.48,1.48,0,0,1-.7-1.16C303.62,60.68,303.93,60.52,304.32,60.74Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,60.74l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.48,1.48,0,0,1-.7-1.16C303.62,60.68,303.93,60.52,304.32,60.74Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,80l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.5,1.5,0,0,1-.7-1.16C303.62,80,303.93,79.81,304.32,80Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,80l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.5,1.5,0,0,1-.7-1.16C303.62,80,303.93,79.81,304.32,80Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,66.12l8.82,5.1a1.48,1.48,0,0,1,.7,1.16c0,.41-.31.57-.7.35L307,67.62a1.48,1.48,0,0,1-.7-1.15C306.26,66.05,306.57,65.9,307,66.12Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,66.12l8.82,5.1a1.48,1.48,0,0,1,.7,1.16c0,.41-.31.57-.7.35L307,67.62a1.48,1.48,0,0,1-.7-1.15C306.26,66.05,306.57,65.9,307,66.12Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,70l8.82,5.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,71.48a1.48,1.48,0,0,1-.7-1.15C306.26,69.91,306.57,69.75,307,70Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,70l8.82,5.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,71.48a1.48,1.48,0,0,1-.7-1.15C306.26,69.91,306.57,69.75,307,70Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,72.32l11.46,6.62a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-11.46-6.62a1.48,1.48,0,0,1-.7-1.15C303.62,72.25,303.93,72.1,304.32,72.32Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,72.32l11.46,6.62a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-11.46-6.62a1.48,1.48,0,0,1-.7-1.15C303.62,72.25,303.93,72.1,304.32,72.32Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,77.69l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,79.19a1.46,1.46,0,0,1-.7-1.15C306.26,77.63,306.57,77.47,307,77.69Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,77.69l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,79.19a1.46,1.46,0,0,1-.7-1.15C306.26,77.63,306.57,77.47,307,77.69Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.28,84.87l20.4,11.77A3,3,0,0,1,319.05,99v46.54c0,.88-.61,1.23-1.37.79l-20.4-11.78a3,3,0,0,1-1.37-2.37V85.66C295.91,84.78,296.52,84.43,297.28,84.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,88.92,301.05,90a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C298.48,88.86,298.79,88.7,299.17,88.92Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,88.92,301.05,90a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C298.48,88.86,298.79,88.7,299.17,88.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,94.3l1.88,1.08a1.5,1.5,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C301.12,94.23,301.43,94.08,301.81,94.3Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,94.3l1.88,1.08a1.5,1.5,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C301.12,94.23,301.43,94.08,301.81,94.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,98.15l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,98.08,301.43,97.92,301.81,98.15Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,98.15l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,98.08,301.43,97.92,301.81,98.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,100.5l1.88,1.08a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35L299.17,102a1.49,1.49,0,0,1-.69-1.15C298.48,100.43,298.79,100.27,299.17,100.5Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,100.5l1.88,1.08a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35L299.17,102a1.49,1.49,0,0,1-.69-1.15C298.48,100.43,298.79,100.27,299.17,100.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,91.9l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,93.4a1.48,1.48,0,0,1-.7-1.15C303.62,91.83,303.93,91.67,304.32,91.9Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,91.9l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,93.4a1.48,1.48,0,0,1-.7-1.15C303.62,91.83,303.93,91.67,304.32,91.9Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,97.27l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,98.77a1.48,1.48,0,0,1-.7-1.15C306.26,97.2,306.57,97.05,307,97.27Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,97.27l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,98.77a1.48,1.48,0,0,1-.7-1.15C306.26,97.2,306.57,97.05,307,97.27Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,101.13l8.82,5.1a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.58-.7.36L307,102.63a1.48,1.48,0,0,1-.7-1.15C306.26,101.06,306.57,100.9,307,101.13Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,101.13l8.82,5.1a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.58-.7.36L307,102.63a1.48,1.48,0,0,1-.7-1.15C306.26,101.06,306.57,100.9,307,101.13Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,103.47l11.46,6.62a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L304.32,105a1.48,1.48,0,0,1-.7-1.15C303.62,103.4,303.93,103.25,304.32,103.47Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,103.47l11.46,6.62a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L304.32,105a1.48,1.48,0,0,1-.7-1.15C303.62,103.4,303.93,103.25,304.32,103.47Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,105.89l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,105.83,301.43,105.67,301.81,105.89Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,105.89l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C301.12,105.83,301.43,105.67,301.81,105.89Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,109.74l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,109.68,301.43,109.52,301.81,109.74Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,109.74l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,109.68,301.43,109.52,301.81,109.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,108.86l8.82,5.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.58-.7.35l-8.82-5.1a1.48,1.48,0,0,1-.7-1.15C306.26,108.8,306.57,108.64,307,108.86Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,108.86l8.82,5.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.58-.7.35l-8.82-5.1a1.48,1.48,0,0,1-.7-1.15C306.26,108.8,306.57,108.64,307,108.86Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,112.72l8.82,5.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,114.22a1.46,1.46,0,0,1-.7-1.15C306.26,112.66,306.57,112.5,307,112.72Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,112.72l8.82,5.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,114.22a1.46,1.46,0,0,1-.7-1.15C306.26,112.66,306.57,112.5,307,112.72Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,119.83l1.88,1.09a1.49,1.49,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C298.48,119.77,298.79,119.61,299.17,119.83Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,119.83l1.88,1.09a1.49,1.49,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C298.48,119.77,298.79,119.61,299.17,119.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,122.8l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.48,1.48,0,0,1-.7-1.15C303.62,122.74,303.93,122.58,304.32,122.8Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,122.8l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.48,1.48,0,0,1-.7-1.15C303.62,122.74,303.93,122.58,304.32,122.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,125.23l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,125.17,301.43,125,301.81,125.23Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,125.23l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,125.17,301.43,125,301.81,125.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,129.08l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C301.12,129,301.43,128.86,301.81,129.08Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,129.08l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C301.12,129,301.43,128.86,301.81,129.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,128.2l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,129.7a1.46,1.46,0,0,1-.7-1.15C306.26,128.14,306.57,128,307,128.2Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,128.2l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,129.7a1.46,1.46,0,0,1-.7-1.15C306.26,128.14,306.57,128,307,128.2Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,132.06l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,133.56a1.48,1.48,0,0,1-.7-1.15C306.26,132,306.57,131.84,307,132.06Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,132.06l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,133.56a1.48,1.48,0,0,1-.7-1.15C306.26,132,306.57,131.84,307,132.06Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,113.57l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,113.51,301.43,113.35,301.81,113.57Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,113.57l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C301.12,113.51,301.43,113.35,301.81,113.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,115.92l1.88,1.09a1.49,1.49,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C298.48,115.86,298.79,115.7,299.17,115.92Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,115.92l1.88,1.09a1.49,1.49,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C298.48,115.86,298.79,115.7,299.17,115.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,116.55l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,118.05a1.46,1.46,0,0,1-.7-1.15C306.26,116.49,306.57,116.33,307,116.55Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,116.55l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,118.05a1.46,1.46,0,0,1-.7-1.15C306.26,116.49,306.57,116.33,307,116.55Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,118.89l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.5,1.5,0,0,1-.7-1.16C303.62,118.83,303.93,118.67,304.32,118.89Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,118.89l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.5,1.5,0,0,1-.7-1.16C303.62,118.83,303.93,118.67,304.32,118.89Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,131.48l1.88,1.09a1.49,1.49,0,0,1,.7,1.15c0,.41-.32.57-.7.35L299.17,133a1.48,1.48,0,0,1-.69-1.15C298.48,131.42,298.79,131.26,299.17,131.48Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,131.48l1.88,1.09a1.49,1.49,0,0,1,.7,1.15c0,.41-.32.57-.7.35L299.17,133a1.48,1.48,0,0,1-.69-1.15C298.48,131.42,298.79,131.26,299.17,131.48Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,134.46l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,136a1.48,1.48,0,0,1-.7-1.15C303.62,134.39,303.93,134.23,304.32,134.46Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,134.46l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,136a1.48,1.48,0,0,1-.7-1.15C303.62,134.39,303.93,134.23,304.32,134.46Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.78,150.29v76.38a3.51,3.51,0,0,0,1.59,2.75l43.88,25.32a1.1,1.1,0,0,0,.53.15l.2,0,.13,0,.09,0,.09-.06.09-.08a1.22,1.22,0,0,0,.29-.42,1.88,1.88,0,0,0,.17-.8v-76a3.5,3.5,0,0,0-1.59-2.75l-43.88-25.29a1.16,1.16,0,0,0-1.07-.14l-.13.08h0l-.11.1a.21.21,0,0,0,0,.06.26.26,0,0,0-.05.09.54.54,0,0,0-.1.2.58.58,0,0,0,0,.14,0,0,0,0,0,0,0l0,.15C410.79,150.16,410.78,150.23,410.78,150.29Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.3,149.24a1.16,1.16,0,0,1,1.07.14l43.88,25.29a3.5,3.5,0,0,1,1.59,2.75v5.18l2.53-1.46V176a3.48,3.48,0,0,0-1.59-2.74L414.9,148a1.11,1.11,0,0,0-1.15-.1C413.46,148,411.64,149.07,411.3,149.24Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.79,150.28c0-1,.71-1.4,1.58-.9l43.88,25.29a3.51,3.51,0,0,1,1.59,2.75v5.18l-47-27.11Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.37,149.38l43.88,25.29a3.27,3.27,0,0,1,1.12,1.18l2.52-1.45a3.23,3.23,0,0,0-1.11-1.15L414.9,148a1.11,1.11,0,0,0-1.15-.1c-.28.18-2.11,1.2-2.44,1.38A1.11,1.11,0,0,1,412.37,149.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.37,181.15V176a3.36,3.36,0,0,0-.48-1.59l-2.53,1.44a3.16,3.16,0,0,1,.48,1.58v5.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.53,176.8a2.37,2.37,0,0,1,.9,1.9c0,.76-.4,1.15-.9.86a2.36,2.36,0,0,1-.9-1.89C454.63,176.9,455,176.52,455.53,176.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.3,174.94a2.33,2.33,0,0,1,.9,1.89c0,.77-.4,1.15-.9.87a2.39,2.39,0,0,1-.89-1.9C451.41,175,451.81,174.65,452.3,174.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.08,173.07A2.39,2.39,0,0,1,450,175c0,.76-.4,1.15-.89.86a2.35,2.35,0,0,1-.9-1.9C448.18,173.17,448.58,172.79,449.08,173.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.26,254.74l.19-.11.49-.28h0a1.74,1.74,0,0,1,.26-.15h0l.42-.24.85-.48.2-.11a.9.9,0,0,0,.27-.21,1.1,1.1,0,0,0,.21-.33,1.89,1.89,0,0,0,.19-.84V181.14l-2.53,1.46v70.81a2.31,2.31,0,0,1-.17.8,1.22,1.22,0,0,1-.29.42.24.24,0,0,1-.09.08Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,164.25a.25.25,0,0,1,.08-.2l1.14-1s0,0,.05,0h0a.17.17,0,0,1,.09.11.29.29,0,0,1,0,.16v.79a1.09,1.09,0,0,1,0,.22.83.83,0,0,1-.08.12l-.61.55.61,1.25c0,.08.06.15.08.22a1.44,1.44,0,0,1,0,.24v.79c0,.06,0,.1,0,.12a.07.07,0,0,1-.09,0l0,0-.05-.07-1.14-2.37a.67.67,0,0,1-.08-.29Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6,163.15a.3.3,0,0,1,.09-.13s.09,0,.17,0l.42.25a.17.17,0,0,1,.09.11.29.29,0,0,1,0,.16.2.2,0,0,1,0,.07l-2,6.08a.26.26,0,0,1-.08.13s-.09,0-.17,0l-.41-.24a.2.2,0,0,1-.09-.11.32.32,0,0,1,0-.16s0-.05,0-.07Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.63,169a.26.26,0,0,1-.08.21l-1.14,1a.07.07,0,0,1-.06,0h0a.2.2,0,0,1-.09-.11.32.32,0,0,1,0-.16v-.79a1,1,0,0,1,0-.22.35.35,0,0,1,.08-.13l.6-.55-.6-1.24a2.11,2.11,0,0,1-.08-.22,1.44,1.44,0,0,1,0-.24v-.8a.12.12,0,0,1,0-.11s.05,0,.09,0l0,0a.22.22,0,0,1,.06.07l1.14,2.36a.67.67,0,0,1,.08.3Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8,172.11a.29.29,0,0,1,.11.13.48.48,0,0,1,0,.2v.87a.18.18,0,0,1,0,.14.08.08,0,0,1-.11,0l-.54-.31a.29.29,0,0,1-.11-.13.49.49,0,0,1,0-.2V172a.21.21,0,0,1,0-.15.08.08,0,0,1,.11,0Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.6,173.15a.29.29,0,0,1,.11.13.48.48,0,0,1,0,.2v.87a.18.18,0,0,1,0,.14.09.09,0,0,1-.11,0l-.54-.31a.36.36,0,0,1-.11-.13.53.53,0,0,1-.05-.2V173a.21.21,0,0,1,.05-.15.08.08,0,0,1,.11,0Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,174.19a.25.25,0,0,1,.11.13.48.48,0,0,1,0,.2v.87a.2.2,0,0,1,0,.14.09.09,0,0,1-.11,0l-.54-.31a.33.33,0,0,1-.11-.14.45.45,0,0,1-.05-.19V174a.2.2,0,0,1,.05-.14.09.09,0,0,1,.11,0Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,171.17l26.36,15.22a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.28l-26.36-15.22a1.21,1.21,0,0,1-.56-.93C414.35,171.12,414.6,171,414.91,171.17Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,190.71l26.36,15.22a1.19,1.19,0,0,1,.57.93c0,.34-.25.47-.57.29l-26.36-15.22a1.21,1.21,0,0,1-.56-.94C422.81,190.65,423.06,190.53,423.37,190.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,200.47,436,207.76a1.21,1.21,0,0,1,.56.94c0,.34-.25.46-.56.28l-12.62-7.29a1.19,1.19,0,0,1-.56-.93C422.81,200.42,423.06,200.29,423.37,200.47Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.46,187.65l10.5,6a1.19,1.19,0,0,1,.57.93c0,.34-.26.47-.57.29l-10.5-6a1.19,1.19,0,0,1-.56-.93C442.9,187.6,443.15,187.47,443.46,187.65Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,224.89l26.36,15.22a1.19,1.19,0,0,1,.57.93c0,.34-.25.47-.57.29l-26.36-15.22a1.21,1.21,0,0,1-.56-.94C414.35,224.83,414.6,224.71,414.91,224.89Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.46,241.37l10.5,6a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-10.5-6a1.21,1.21,0,0,1-.56-.94C442.9,241.32,443.15,241.19,443.46,241.37Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.46,226.74l10.5,6a1.2,1.2,0,0,1,.57.93c0,.34-.26.47-.57.29l-10.5-6a1.21,1.21,0,0,1-.56-.94C442.9,226.69,443.15,226.56,443.46,226.74Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.46,231.63l10.5,6a1.22,1.22,0,0,1,.57.93c0,.34-.26.47-.57.29l-10.5-6a1.21,1.21,0,0,1-.56-.94C442.9,231.57,443.15,231.45,443.46,231.63Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5,221.56l5.9,3.41a1.18,1.18,0,0,1,.57.93c0,.34-.25.47-.57.29l-5.9-3.41a1.21,1.21,0,0,1-.56-.94C433.94,221.51,434.19,221.38,434.5,221.56Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,176.07l15.38,8.87a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-15.38-8.87a1.21,1.21,0,0,1-.56-.94C414.35,176,414.6,175.89,414.91,176.07Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,176.07l15.38,8.87a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-15.38-8.87a1.21,1.21,0,0,1-.56-.94C414.35,176,414.6,175.89,414.91,176.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,180.94l5.22,3a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.21,1.21,0,0,1-.56-.93C414.35,180.89,414.6,180.76,414.91,180.94Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,180.94l5.22,3a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.21,1.21,0,0,1-.56-.93C414.35,180.89,414.6,180.76,414.91,180.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,185.82l5.22,3a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-5.22-3a1.18,1.18,0,0,1-.56-.93C414.35,185.77,414.6,185.64,414.91,185.82Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,185.82l5.22,3a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-5.22-3a1.18,1.18,0,0,1-.56-.93C414.35,185.77,414.6,185.64,414.91,185.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,190.71l5.22,3a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.21,1.21,0,0,1-.56-.94C414.35,190.65,414.6,190.53,414.91,190.71Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,190.71l5.22,3a1.21,1.21,0,0,1,.56.94c0,.34-.25.46-.56.28l-5.22-3a1.21,1.21,0,0,1-.56-.94C414.35,190.65,414.6,190.53,414.91,190.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,195.59l15.38,8.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-15.38-8.87a1.21,1.21,0,0,1-.56-.94C422.81,195.54,423.06,195.41,423.37,195.59Z",
    style: {
      fill: "#8C6F6F",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,205.72l6.69,3.88a1.18,1.18,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.21,1.21,0,0,1-.56-.93C440.37,205.67,440.62,205.54,440.93,205.72Z",
    style: {
      fill: "#8C6F6F",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,195.59l15.38,8.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-15.38-8.87a1.21,1.21,0,0,1-.56-.94C422.81,195.54,423.06,195.41,423.37,195.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,205.72l6.69,3.88a1.18,1.18,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.21,1.21,0,0,1-.56-.93C440.37,205.67,440.62,205.54,440.93,205.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,195.59l5.22,3a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.21,1.21,0,0,1-.56-.93C414.35,195.54,414.6,195.41,414.91,195.59Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,195.59l5.22,3a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.21,1.21,0,0,1-.56-.93C414.35,195.54,414.6,195.41,414.91,195.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.47,186.2l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.21,1.21,0,0,1-.56-.94C431.91,186.15,432.16,186,432.47,186.2Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.47,186.2l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.21,1.21,0,0,1-.56-.94C431.91,186.15,432.16,186,432.47,186.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.71,209l15.38,8.87a1.22,1.22,0,0,1,.57.94c0,.34-.26.46-.57.29l-15.38-8.88a1.21,1.21,0,0,1-.56-.93C429.15,209,429.4,208.83,429.71,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.59,219,454,227.91a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-15.37-8.87a1.2,1.2,0,0,1-.57-.94C438,219,438.27,218.86,438.59,219Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.28,219.15,454,223a1.22,1.22,0,0,1,.57.93c0,.34-.26.47-.57.29l-6.68-3.87a1.2,1.2,0,0,1-.57-.94C446.71,219.09,447,219,447.28,219.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.28,238.49l6.68,3.87a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-6.68-3.87a1.2,1.2,0,0,1-.57-.94C446.71,238.44,447,238.31,447.28,238.49Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,185.82l15.38,8.88a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29L423.37,187a1.18,1.18,0,0,1-.56-.93C422.81,185.77,423.06,185.64,423.37,185.82Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,185.82l15.38,8.88a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29L423.37,187a1.18,1.18,0,0,1-.56-.93C422.81,185.77,423.06,185.64,423.37,185.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,196l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.21,1.21,0,0,1-.56-.94C440.37,195.9,440.62,195.78,440.93,196Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,196l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.21,1.21,0,0,1-.56-.94C440.37,195.9,440.62,195.78,440.93,196Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.12,251.91l9.42,5.44a10.38,10.38,0,0,0,10.4-.55l15.55-11.35c2.77-2,2.61-5-.36-6.77l-4.72-2.74a12.83,12.83,0,0,0-10.93-.33L336.29,246C333.22,247.55,333.14,250.19,336.12,251.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.74,240.51,361,248.92l-7.94,6.21a7,7,0,0,1-2.53.61,6.88,6.88,0,0,1-3.77-.79l-8.43-4.87a0,0,0,0,1,0,0l-.05,0a6,6,0,0,1-1.71-8.53l.25-.35a11.24,11.24,0,0,1,6.79-4.3l4.27-.85c6.92-1.41,12.59-2.09,13.25-1.64l10.57,6.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,245.22l.61-.48-9.49-5.47,8.3-2.57-.84-.49-8.3,2.57-5.66-3.26-1.07.2Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,254.62l0,0h0l7.56-5.46,10.19-7.36V240.6a.1.1,0,0,0-.05-.09l-.06,0c-.76-.26-5.18,1.07-10.52,3.19l-3.54,1.41a11.21,11.21,0,0,0-7.1,10.47v.18a7,7,0,0,0,2.53-.61Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.7,405.51c-10.38-10.71-16.47-54.29-6.35-62.78h51.5c10.12,8.49,4,52.06-6.34,62.77l-.29.3c-.11.12-.23.24-.35.35-.3.29-.61.57-.94.84l-.25.2c-.25.2-.5.4-.78.6a15.26,15.26,0,0,1-1.34.87c-8.54,5-22.38,5-30.92,0h0c-.45-.26-.9-.56-1.35-.88-.26-.18-.49-.37-.73-.56l-.3-.24a12.15,12.15,0,0,1-.91-.81c-.14-.13-.28-.27-.41-.41A2.83,2.83,0,0,1,372.7,405.51Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.7,405.51c-10.38-10.71-16.47-54.29-6.35-62.78h51.5c10.12,8.49,4,52.06-6.34,62.77l-.29.3c-.11.12-.23.24-.35.35-.3.29-.61.57-.94.84l-.25.2c-.25.2-.5.4-.78.6a15.26,15.26,0,0,1-1.34.87c-8.54,5-22.38,5-30.92,0h0c-.45-.26-.9-.56-1.35-.88-.26-.18-.49-.37-.73-.56l-.3-.24a12.15,12.15,0,0,1-.91-.81c-.14-.13-.28-.27-.41-.41A2.83,2.83,0,0,1,372.7,405.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.38,339.31c11.75,6.86,11.75,18,0,24.85s-30.81,6.86-42.56,0-11.75-18,0-24.85S401.63,332.45,413.38,339.31Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.38,339.31c11.75,6.86,11.75,18,0,24.85s-30.81,6.86-42.56,0-11.75-18,0-24.85S401.63,332.45,413.38,339.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.73,342.61c8.63,5,8.63,13.21,0,18.25s-22.63,5-31.26,0-8.63-13.21,0-18.25S399.1,337.57,407.73,342.61Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407.73,342.61c8.63,5,8.63,13.21,0,18.25s-22.63,5-31.26,0-8.63-13.21,0-18.25S399.1,337.57,407.73,342.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,351.27c8.63-5,22.63-5,31.26,0a14.36,14.36,0,0,1,5.16,4.79,14.38,14.38,0,0,1-5.16,4.8c-8.63,5-22.63,5-31.26,0a14.5,14.5,0,0,1-5.17-4.8A14.48,14.48,0,0,1,376.47,351.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.88,329.28a14.43,14.43,0,0,1-1.31-3.76c-.58-3.14.2-6.73,2.74-8.67,1-.76,2.33-1.33,2.76-2.53a4.14,4.14,0,0,0,0-2.07c-.47-2.68-1.37-5.44-.63-8.05a9,9,0,0,1,5-5.36,27,27,0,0,1,7.27-1.9,11.77,11.77,0,0,0,3.85-1.1c1.44-.81,1.89-2.23,2.78-3.48a24.3,24.3,0,0,1,3.54-3.77c2.62-2.34,5.9-4.27,9.53-4.11,7.58.33,7.36,6.85,5.18,11.79s-2.76,6.55,2,11.7,4.74,11.5-.91,15-9.32,4-7.08,10.86c2,6.11,3.23,11.32-2.41,17.85-3.65,4.22-8.64,7.23-14.88,7A25.12,25.12,0,0,1,398,357c-1.72-.85-.56-2.18-1.14-3.88l-3.74-10.92a81.09,81.09,0,0,0-3-8.62C389.43,332.08,388.59,330.71,387.88,329.28Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.88,329.28a14.43,14.43,0,0,1-1.31-3.76c-.58-3.14.2-6.73,2.74-8.67,1-.76,2.33-1.33,2.76-2.53a4.14,4.14,0,0,0,0-2.07c-.47-2.68-1.37-5.44-.63-8.05a9,9,0,0,1,5-5.36,27,27,0,0,1,7.27-1.9,11.77,11.77,0,0,0,3.85-1.1c1.44-.81,1.89-2.23,2.78-3.48a24.3,24.3,0,0,1,3.54-3.77c2.62-2.34,5.9-4.27,9.53-4.11,7.58.33,7.36,6.85,5.18,11.79s-2.76,6.55,2,11.7,4.74,11.5-.91,15-9.32,4-7.08,10.86c2,6.11,3.23,11.32-2.41,17.85-3.65,4.22-8.64,7.23-14.88,7A25.12,25.12,0,0,1,398,357c-1.72-.85-.56-2.18-1.14-3.88l-3.74-10.92a81.09,81.09,0,0,0-3-8.62C389.43,332.08,388.59,330.71,387.88,329.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M398.18,357a.53.53,0,0,0,.37-.53c-.32-37.42,20.31-59.76,20.52-60a.58.58,0,0,0,0-.8.56.56,0,0,0-.79,0c-.21.22-21.14,22.87-20.82,60.76a.55.55,0,0,0,.56.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,322.17l.12-.05c6.71-4.23,18.68-7.38,18.8-7.41a.57.57,0,0,0,.4-.69.55.55,0,0,0-.68-.4c-.5.13-12.26,3.22-19.11,7.54a.55.55,0,0,0-.18.77A.55.55,0,0,0,404.18,322.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.26,317h0a.57.57,0,0,0,.31-.74,43.53,43.53,0,0,0-6.19-10.41.55.55,0,0,0-.79-.06.57.57,0,0,0-.06.79,42.89,42.89,0,0,1,6,10.11A.55.55,0,0,0,406.26,317Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,361a31.45,31.45,0,0,1-16.43.6c-9.42-2-15.19-10.84-15.19-10.84s10.2-4.08,16.14-4.48a52.62,52.62,0,0,0-17.85.38s-5.46-2-4.43-11.24c0,0,5.14-3.79,17-2.3,0,0-5.92-4.23-16.31-5.48-.82,0,.29-12,1.28-17.35s3-4.52,7.2-4.06,16.81,3.32,18.4,6.4.05,10.94.05,10.94a18,18,0,0,0,3.46-10.28s4.73,1.73,7.26,4a16.82,16.82,0,0,1,4.52,5.66c-.59,4.21-2.57,10.64-5.35,14.23,0,0,6.26-4.05,7.69-11.49a26,26,0,0,1,5,14.65C405.22,349.75,401,356.74,392.92,361Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,361a31.45,31.45,0,0,1-16.43.6c-9.42-2-15.19-10.84-15.19-10.84s10.2-4.08,16.14-4.48a52.62,52.62,0,0,0-17.85.38s-5.46-2-4.43-11.24c0,0,5.14-3.79,17-2.3,0,0-5.92-4.23-16.31-5.48-.82,0,.29-12,1.28-17.35s3-4.52,7.2-4.06,16.81,3.32,18.4,6.4.05,10.94.05,10.94a18,18,0,0,0,3.46-10.28s4.73,1.73,7.26,4a16.82,16.82,0,0,1,4.52,5.66c-.59,4.21-2.57,10.64-5.35,14.23,0,0,6.26-4.05,7.69-11.49a26,26,0,0,1,5,14.65C405.22,349.75,401,356.74,392.92,361Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,360.19a.52.52,0,0,1-.34-.46c-1.43-17.86-21.41-45.75-30.24-51.35a.56.56,0,0,1-.17-.75.55.55,0,0,1,.74-.17c9,5.69,29.29,34,30.73,52.18a.53.53,0,0,1-.49.58A.45.45,0,0,1,394.17,360.19Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.49,349c0-.2-3.21-11.8-3.21-11.8s1.05,1.07,7.75-.7a38,38,0,0,0,7.29-3.06l1.91,8.48c1.79,3.26,7.71,1.76,14.19,1,1.09-.13,2.21-.31,3.33-.5h.07c3.5-.19,7,1.91,3.38,4.9s-9.65,4.11-15.18,5.11C226.36,353.68,214.68,355.63,213.49,349Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,348a6.79,6.79,0,0,1,.48,3.56c-.12,1.29-3.32,5.67-9,8.36s-12.62,2.86-15.88,3.8-6.26,2.81-10.11,3.75-7.66,1.44-11.52-1.11c-.71-1.09-1.49-3.62-1.27-3.87C213.4,361.83,260,348,260,348Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,343.08c2.48,1.71,7.62.52,13.17-.11,5.24-.6,11.13-2.44,14.69-1.2s6.53,5.42,1.72,10.79c-1.39,1.55-4.33,4.28-6.69,5.13-6,2.14-11.34,2.31-15.18,3.26-5,1.23-7.74,3.45-12.36,4-6,.7-9.78-.84-10.82-2.44s-2-14.49.57-14.22c0,0,1.08,4.17,10.87.12C228.49,346.62,228.42,344,228.25,343.08Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,343.08c2.48,1.71,7.62.52,13.17-.11,5.24-.6,11.13-2.44,14.69-1.2s6.53,5.42,1.72,10.79c-1.39,1.55-4.33,4.28-6.69,5.13-6,2.14-11.34,2.31-15.18,3.26-5,1.23-7.74,3.45-12.36,4-6,.7-9.78-.84-10.82-2.44s-2-14.49.57-14.22c0,0,1.08,4.17,10.87.12C228.49,346.62,228.42,344,228.25,343.08Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.85,350s-.56-5.44-4.58-6.88a2.11,2.11,0,0,0-2.22.29s3.73.54,5,6.93c0,0,.19.42,1,.27C244.29,350.55,244.89,350.44,244.85,350Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,343.82s0-.18.94-.35a1.68,1.68,0,0,1,1.11.12s3,1.3,3.56,7c0,0,0,.68-.93.87a.82.82,0,0,1-1.07-.56S237.61,344.91,234.62,343.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.4,343.94s.17-.34.87-.34c.89,0,1.1.35,1.1.35s2.14,2.19,2.16,6.95c0,0,.09.8-1,.88s-1-.82-1-.82S233.15,344.9,231.4,343.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,270.2c4.9,14.73,17.9,65.45,17.9,65.45s-8.46,7.6-17.64,4.14l-21.87-63.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.14,365.4c-1-1.49-4.76-11.8-4.76-11.8s3.92,2.24,10.67.64c3.43-.82,6.64-4.54,6.64-4.54l2.88,9.91c1.7,3.31,7.21,2.22,13.71,1.64,1.09-.1,2.21-.26,3.34-.42h.07c3.5-.1,7,2.08,3.25,5s-9.74,3.88-15.3,4.74C261,371.58,250.89,371,247.14,365.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.56,365.09a7.31,7.31,0,0,1,.43,3.84c-.17,1.38-3.72,6-9.84,8.73s-13.63,2.74-17.16,3.66-6.79,2.86-10.95,3.77-8.26,1.33-12.33-1.49c-.74-1.2-1.52-3.94-1.26-4.2C247.12,378.71,297.56,365.09,297.56,365.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.63,358.87a10.44,10.44,0,0,0,1.23.76,3.67,3.67,0,0,0,1.36.28,18.9,18.9,0,0,0,3.28.08c2.74-.13,5.47-.55,8.21-.79,5.63-.5,12-2.32,15.79-.9s7.25,6,1.94,11.61a26,26,0,0,1-7.1,5.39c-6.29,2.63-12.82,2.14-17,3.06-5.4,1.19-8.4,3.5-13.38,3.95-6.45.59-10.47-1.16-11.54-2.91-.6-1,.06-6-.74-9.95-.7-3.38-.52-5.68.7-5.53a6,6,0,0,0,.94,1.2,4.51,4.51,0,0,0,1.43,1.13,11.29,11.29,0,0,0,2.42.81,14.29,14.29,0,0,0,4.49.62,2.18,2.18,0,0,0,1.22-.39,2.57,2.57,0,0,0,.71-1.52c.1-.5.21-1,.31-1.5a2.1,2.1,0,0,1,.28-.77,2,2,0,0,1,.76-.61,6.56,6.56,0,0,0,2.46-1.87,5.78,5.78,0,0,0,.72-2.32.57.57,0,0,1,.16-.38c.18-.14.45,0,.65.11Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.63,358.87a10.44,10.44,0,0,0,1.23.76,3.67,3.67,0,0,0,1.36.28,18.9,18.9,0,0,0,3.28.08c2.74-.13,5.47-.55,8.21-.79,5.63-.5,12-2.32,15.79-.9s7.25,6,1.94,11.61a26,26,0,0,1-7.1,5.39c-6.29,2.63-12.82,2.14-17,3.06-5.4,1.19-8.4,3.5-13.38,3.95-6.45.59-10.47-1.16-11.54-2.91-.6-1,.06-6-.74-9.95-.7-3.38-.52-5.68.7-5.53a6,6,0,0,0,.94,1.2,4.51,4.51,0,0,0,1.43,1.13,11.29,11.29,0,0,0,2.42.81,14.29,14.29,0,0,0,4.49.62,2.18,2.18,0,0,0,1.22-.39,2.57,2.57,0,0,0,.71-1.52c.1-.5.21-1,.31-1.5a2.1,2.1,0,0,1,.28-.77,2,2,0,0,1,.76-.61,6.56,6.56,0,0,0,2.46-1.87,5.78,5.78,0,0,0,.72-2.32.57.57,0,0,1,.16-.38c.18-.14.45,0,.65.11Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,366.83s-.46-5.86-4.74-7.51a2.28,2.28,0,0,0-2.39.25s4,.68,5.14,7.57c0,0,.2.46,1.08.32C280.58,367.42,281.23,367.32,281.2,366.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.38,359.94s0-.2,1-.36a1.78,1.78,0,0,1,1.18.16s3.19,1.47,3.64,7.6c0,0,0,.73-1,.91a.89.89,0,0,1-1.14-.63S273.57,361.18,270.38,359.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92,360s.19-.36.95-.34c.95,0,1.16.4,1.16.4s2.24,2.41,2.14,7.51c0,0,.08.87-1.13.93s-1-.91-1-.91S268.78,361.05,266.92,360Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.84,287.59c3.86,11.87,13.72,45.66,18.22,63,0,0-8.09,7.28-18.5,6.64l-25.09-65.06,10-6.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23,450a1.63,1.63,0,0,0,1.63-1.63V343.81a1.63,1.63,0,0,0-3.26,0V448.4A1.63,1.63,0,0,0,161.23,450Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52,412a1.62,1.62,0,0,0,1.51-1l32.07-81.18a1.62,1.62,0,1,0-3-1.19L95,409.73a1.63,1.63,0,0,0,.91,2.11A1.61,1.61,0,0,0,96.52,412Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37,402.21a1.61,1.61,0,0,0,1.18-.51l59.68-63.15,59.57,62.88a1.63,1.63,0,0,0,2.36-2.24l-60.75-64.13a1.64,1.64,0,0,0-1.18-.51h0a1.63,1.63,0,0,0-1.18.51l-60.86,64.4a1.63,1.63,0,0,0,1.18,2.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,412a1.61,1.61,0,0,0,.6-.12,1.63,1.63,0,0,0,.91-2.11l-32.07-81.17a1.63,1.63,0,1,0-3,1.19l32.08,81.18A1.62,1.62,0,0,0,225.94,412Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.72,307.94c1.17-6.56-4.17-11.68-14.23-18.47a238.45,238.45,0,0,0-29.13-16.37c-8.42-3.86-17-3.5-27.79,2-15,7.69-60,35-60,35s67.32,38,80.27,36.3,45.32-22.76,47.89-30.17S226.72,307.94,226.72,307.94Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.72,307.94c1.17-6.56-4.17-11.68-14.23-18.47a238.45,238.45,0,0,0-29.13-16.37c-8.42-3.86-17-3.5-27.79,2-15,7.69-60,35-60,35s67.32,38,80.27,36.3,45.32-22.76,47.89-30.17S226.72,307.94,226.72,307.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M169.35,338.43c9.66,8.75,19.76,1.22,35.74-9.15,18.09-11.73,21.63-21.34,21.63-21.34s0,7.2-1.35,10.57-4.27,7.2-17.31,16.19-22.49,13.49-31.26,15.16l-6.92-.95",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.09,329.28c18.09-11.73,21.63-21.34,21.63-21.34s0,7.2-1.35,10.57-4.27,7.2-17.31,16.19-22.49,13.49-31.26,15.16l-6.92-.95-.53-10.48C179,347.18,189.11,339.65,205.09,329.28Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,399.22l-5,11.42a1.59,1.59,0,0,0-.06.3,1.34,1.34,0,0,0,0,.21,1.41,1.41,0,0,0,.63.76,3,3,0,0,0,2.68.13,1.18,1.18,0,0,0,.55-.53v0l0-.15,4.6-10.71Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.73,399.7,228,410.89a1.35,1.35,0,0,1,0,.29v.2a1.31,1.31,0,0,1-.64.7,2.8,2.8,0,0,1-2.58,0,1.15,1.15,0,0,1-.51-.52v0l0-.16-3.93-10.49Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.35,440.3v9.26a1,1,0,0,0,.55.76,2.9,2.9,0,0,0,2.66,0,.93.93,0,0,0,.54-.76V440.3A4,4,0,0,0,159.35,440.3Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,268.72c3.83,4.47,38.72-5.57,48-6.83,14.9-2,27-3.51,32.1-1.92s7.21,4.17,8.76,10.23c1.83,7.14,2.77,10.79,2.77,10.79s-24.76,9.5-44.3,11.79S122.54,268.72,122.54,268.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,275.27c-3.87,14.74-7.34,31.88,1.61,41.26,6,6.32,36.31,22.74,55.85,16.27,19.24-6.37,59.1-36,63.1-38.93s7.63-5,7.25-6.28c-5.37-17.84-13.23-19.24-27.79-16-17.82,3.92-56.92,19.87-56.92,19.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.52 180.52 191.08 195.71 169.38 185.41 184.55 164.42 204.52 180.52",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.19,151.66s5.5,7.94,4.91,8.75-4.48,1.61-4.48,1.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,156.91a6.58,6.58,0,1,1,6.58-6.58A6.59,6.59,0,0,1,221.15,156.91Zm0-11.95a5.37,5.37,0,1,0,5.37,5.37A5.38,5.38,0,0,0,221.15,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.92,129.68c10.81,2,14,6.68,15.43,23.75,1.46,17.83-.23,23.49-2.52,25.94-1.55,1.66-10.34,2.16-14.81,1-5.59-1.41-18.25-5.57-24.33-14.42-7.16-10.41-9.31-24.69-2-30.73C187.89,126.75,201.52,128.86,205.92,129.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.52,180.52c4.65,1,11.73.41,13.83-.79a16,16,0,0,1-7.83-.29,25.61,25.61,0,0,1-7.17-3.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,136.67l0,0c-3,2.08-6.7,2.94-10.32,3.51.28,2.89-.63,5.75-1.53,8.52-.62,1.91-2.87,7.92-5.32,4.62-1.77-2.38-3.37-4.55-6.76-4-5.58,1-6.17,8.11-2.54,12.37s6.88,2.52,6.88,2.52.51,7.69-3.55,13.13c0,0-6.05,3.72-14.55.92-5.36-1.77-13.1-8.53-15.95-13.81-7.85-14.52-7.89-28.44,1.63-32.72.88-7,6.27-10.2,12.46-11.77,8.59-2.18,17.51,3.21,25.81-.35,1.75-.75,3.36-1.81,5.15-2.46a3.56,3.56,0,0,1,3.09,0,3.76,3.76,0,0,1,1.32,2.36,6.62,6.62,0,0,1-.33,5,15,15,0,0,1,3.91-1.44,4.9,4.9,0,0,1,3.94.89,5.07,5.07,0,0,1,1.58,3.44C228.58,131.07,226.35,134.58,223.35,136.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19,134.12l-6.52-3.65a3.74,3.74,0,1,1,6.52,3.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.97,
    y: 150.88,
    width: 21.26,
    height: 1.03,
    transform: "translate(-24.1 42.31) rotate(-10.57)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,189.4c-.56-.94-1.81-1.13-2.85-1.49-1.92-.67-3.42-2.2-5.27-3a10.4,10.4,0,0,0-6.66-.45,16.88,16.88,0,0,0-2.22.71,27.94,27.94,0,0,0-4,2c-5.3,3.13-9.28,10.22-14.49,13.47-1.94,1.21-3.75,2.31-5.54,3.41L221.3,215.1a74.46,74.46,0,0,1,6.14-4.67c3.06-1.82,6.15-1.86,9.59-2.36a47.58,47.58,0,0,0,7-1.75,3.09,3.09,0,0,0,2.07-1.35,2.08,2.08,0,0,0-1.34-2.56,18,18,0,0,0-3.63-.5c-.9-.14-3.3.39-3.83-.51-.28-.48.07-1.06.41-1.49,2.16-2.69,4.89-5.57,8.34-6.38a7.24,7.24,0,0,0,3-1.21A2.39,2.39,0,0,0,249.86,189.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,177c-13.21-7.21-25.24-2.58-29.57,6.69-3.93,8.39-12.17,40.85-12.17,40.85C137.69,232,175.47,177,175.47,177Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,179.6l2-2.61c-14.92-7.08-28.27,2.22-40,20.52-12.68,19.72-19.33,48-19.39,77.91,0,0,2.53,13.43,19.49,20.14,18,7.13,43.11,4.11,50.94-14.55,0,0,.16-18.63,5.82-27.81,3.67-5.94,12.22-19.13,18.58-28.6,5.54-8.24,9.85-27-1.72-33.85a98.25,98.25,0,0,0-9.41-4.8C189.22,189.43,172.13,183.78,173.49,179.6Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.53,179.67l1.94-2.68c-14.92-7.08-28.27,2.22-40,20.52-12.68,19.72-19.33,48-19.39,77.91,0,0,2.53,13.43,19.49,20.14,18,7.13,43.11,4.11,50.94-14.55,0,0,.16-18.63,5.82-27.81,3.67-5.94,12.22-19.13,18.58-28.6,5.54-8.24,9.85-27-1.72-33.85a98.25,98.25,0,0,0-9.41-4.8C189.22,189.43,172.17,183.85,173.53,179.67Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7,212.65a30.2,30.2,0,0,0,.46-10.86h0A58,58,0,0,1,204.9,219c-6.07,6.39-13.56,11.37-19.19,18.15-6,7.18-10.25,15.87-15.25,23.71-2,3.15-4.74,9.22-8.46,9.47-4.54.29-8.88-5.24-11.35-9.06-4-6.08-7.34-13.69-12.25-19-4.29-4.67-10.93-10.65-16.77-7.94h0c-.44,1.55-.85,3.12-1.24,4.7s-.75,3.22-1.09,4.83c0,.06,0,.13,0,.19-.33,1.62-.64,3.25-.93,4.88a2,2,0,0,1,0,.26q-.42,2.43-.75,4.86a157.64,157.64,0,0,0-1.49,21.41s2.53,13.43,19.49,20.14c18,7.13,43.11,4.11,50.94-14.55,0,0,.16-18.63,5.82-27.81.57-.92,1.27-2,2-3.27h0l.13-.21c.65-1,1.35-2.13,2.11-3.31,0-.07.09-.14.14-.21a.41.41,0,0,1,0-.09c1.62-2.53,3.44-5.33,5.32-8.22l.85-1.31c1.82-2.78,3.67-5.59,5.43-8.24l0,0c.59-.89,1.17-1.76,1.75-2.61.24-.37.49-.73.72-1.09h0c.2-.29.4-.61.59-.93l.18-.3.42-.74.18-.34.45-.88a2.4,2.4,0,0,1,.11-.23c.19-.39.37-.79.55-1.2l0-.05,0-.07c.16-.38.32-.76.47-1.14,0-.1.07-.19.1-.28.14-.37.28-.74.41-1.11l0-.09,0-.13c.24-.69.46-1.41.66-2.13v0c.2-.73.38-1.47.54-2.21v-.09Z",
    style: {
      fill: "#8C6F6F",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.89,230.8a27.57,27.57,0,0,1-3.1,3.2c-4.56,4.13-9.89,6.12-16.09,10.14-5,3.25-12.73,8-19.24,12.05a97.27,97.27,0,0,1-21,9.68c-6,1.78-9.43,1.85-13-7.83-1.75-4.75-3.14-9.63-4.66-14.46q-3.37-10.79-6.64-21.61s-8-19.83,10-29.79c7.83,4.48,10.81,6.29,13.27,15.67,2.94,11.23,7.7,33.39,7.7,33.39a156.74,156.74,0,0,0,18.59-7.92c2.28-1.13,5.09-1.92,6.72-3.95a30.18,30.18,0,0,0,2.86-4.46c.77-1.38,1.32-2.88,2.17-4.2a37.21,37.21,0,0,1,5.91-6.51,2.43,2.43,0,0,1,1.43-.85,1.66,1.66,0,0,1,1.45.88c.66,1.16.05,2.29-.29,3.47-.39,1.35-.78,2.7-1.16,4A35.25,35.25,0,0,0,281.28,211a5.87,5.87,0,0,1,.9-1.14,1.74,1.74,0,0,1,1.34-.49c1.2.15,2.39,2.09,2.45,3.2a18.23,18.23,0,0,0,.09,3.39c.27,1,1,1.9,1.31,2.92a17,17,0,0,1,.68,3.24,11.1,11.1,0,0,1-1.82,6.79A16,16,0,0,1,284.89,230.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.08,191.35c6.85,2.77,11.79,5.9,14.91,16.36S231.51,235,231.51,235s.06,3.51-8.26,8.42a20.48,20.48,0,0,1-16.11,2.17l-6.28-20.2S189.72,198.33,210.08,191.35Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88,348.91c-5.5-.28-9.81-4.32-22.89-9.77C122.83,329.07,104.71,321,97.8,308.36s-11.79-49.18-10.06-65a20.35,20.35,0,0,1,1.18-5.24l-1.7-.25,4.4-3.75h0c4.52-3.68,11.86-.4,17.4,2.62,15.82,8.6,28.19,17,38,47.17,7.35,22.71,12.2,43.43,22.36,54.51",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.92,238.12l-1.7-.25,4.4-3.75h0c4.52-3.68,11.86-.4,17.4,2.62,15.82,8.6,28.19,17,38,47.17,7.35,22.71,12.2,43.43,22.36,54.51l.53,10.48c-5.5-.28-9.81-4.32-22.89-9.77C122.83,329.07,104.71,321,97.8,308.36s-11.79-49.18-10.06-65A20.78,20.78,0,0,1,88.92,238.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,240.64c15.81,8.6,28.18,17,38,47.17s15.13,56.88,34.4,62.05c0,0-8.71,3.47-35.41-7.83-8.5-3.59-18.81-10.14-25.58-13.94-13.27-7.45-21.32-13.55-22.59-15.84-7-12.59-11.79-49.18-10.07-65S96.51,236.32,104.44,240.64Z",
    style: {
      fill: "#8C6F6F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.34,106.69,189,98.48l3.51-10.15V82.12l-10.75,6.21v6.21l4.62,8a.62.62,0,0,0,.32.28h0Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,106.69,189,98.48l3.51-10.15V82.12l-10.75,6.21v6.21l4.62,8a.62.62,0,0,0,.32.28h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,32.75a7.14,7.14,0,0,0-3.23-5.59l-2.62-1.51a7.12,7.12,0,0,0-6.45,0L166.45,48.94a7.13,7.13,0,0,0-3.22,5.59V98.84a7.13,7.13,0,0,0,3.22,5.58l2.63,1.52a7.12,7.12,0,0,0,6.45,0l12.95-7.48,4.62,8a.68.68,0,0,0,1.24-.12l4.88-14.08,16.58-9.6A7.14,7.14,0,0,0,219,77.06Z",
    style: {
      fill: "#8C6F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.23,98.84a7.13,7.13,0,0,0,3.22,5.58l2.63,1.52a7.21,7.21,0,0,0,5.9.26c-1.52.57-2.68-.28-2.68-2.12V59.77a6.64,6.64,0,0,1,.95-3.18l-9.08-5.24a6.62,6.62,0,0,0-.94,3.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,31.83c-.37-1.37-1.62-1.8-3.11-.95l-40.28,23.3a6.37,6.37,0,0,0-2.27,2.41l-9.08-5.24a6.58,6.58,0,0,1,2.27-2.4l40.27-23.3a7.12,7.12,0,0,1,6.45,0l2.64,1.52A7.08,7.08,0,0,1,218.92,31.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.23,77.16a2.36,2.36,0,0,1,.16-.92,7,7,0,0,1,.47-.86l8.76-14.15a.66.66,0,0,1,.14-.17l.1-.07a.24.24,0,0,1,.32,0,.58.58,0,0,1,.14.43v5.46a2.34,2.34,0,0,1-.26,1.14,7.16,7.16,0,0,1-.44.75l-4.52,6.88,4.52,2.08a1.92,1.92,0,0,1,.44.21c.17.11.26.39.26.83v3.88a1.3,1.3,0,0,1-.14.58.83.83,0,0,1-.32.4l-.1,0a.23.23,0,0,1-.14,0l-8.76-4a1.18,1.18,0,0,1-.47-.32,1.17,1.17,0,0,1-.16-.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.31,55.3a5.6,5.6,0,0,1,.33-.88,1.59,1.59,0,0,1,.64-.69L201.21,52a.26.26,0,0,1,.34,0,.61.61,0,0,1,.14.44,1.47,1.47,0,0,1,0,.33l-7.4,31.54a4.25,4.25,0,0,1-.31.85,1.59,1.59,0,0,1-.65.71l-2.87,1.66a.26.26,0,0,1-.34,0,.56.56,0,0,1-.14-.44,1.33,1.33,0,0,1,0-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,60.4a2.3,2.3,0,0,1-.16.92,7,7,0,0,1-.47.86L204,76.34a1.31,1.31,0,0,1-.14.16l-.1.08a.25.25,0,0,1-.33,0,.55.55,0,0,1-.13-.43V70.67a2.24,2.24,0,0,1,.25-1.12c.17-.3.32-.54.45-.73l3.83-5.92L204,61.44a1.6,1.6,0,0,1-.45-.23c-.17-.12-.25-.4-.25-.85V54.9a1.33,1.33,0,0,1,.13-.58.93.93,0,0,1,.33-.39l.1,0H204l8.76,4a.87.87,0,0,1,.63,1Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-boxes--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,27.2,42.61,58.25a2.94,2.94,0,0,0-1.34,2.31V90.65A2.92,2.92,0,0,0,42.61,93l5.32,3a3,3,0,0,0,2.68,0l53.89-31a3,3,0,0,0,1.34-2.32V32.52a2.9,2.9,0,0,0-1.34-2.3l-5.32-3A3,3,0,0,0,96.5,27.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,32.28c-.1-.68-.65-.92-1.32-.54L50.62,62.79a2.77,2.77,0,0,0-.95,1l-8-4.59a2.63,2.63,0,0,1,.92-1l53.89-31a3,3,0,0,1,2.68,0l5.32,3A3,3,0,0,1,105.82,32.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,31.75l-53.89,31a3,3,0,0,0-1.33,2.32V95.19c0,.85.6,1.2,1.33.77l53.89-31a3,3,0,0,0,1.34-2.32V32.52C105.84,31.67,105.24,31.32,104.5,31.75Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,70.5c0,.24,0,.56,0,1s0,.83,0,1.26,0,.86,0,1.27,0,.73,0,1A5.86,5.86,0,0,0,62.75,76a1.7,1.7,0,0,0,.38.76,1,1,0,0,0,.65.3,1.86,1.86,0,0,0,1-.32,3.79,3.79,0,0,0,1-.77,4.52,4.52,0,0,0,1-1.76c.08-.3.15-.56.19-.8a3.45,3.45,0,0,1,.19-.71.9.9,0,0,1,.4-.4L69.75,71a.21.21,0,0,1,.27,0,.49.49,0,0,1,.11.35,10.35,10.35,0,0,1-.43,2.79,12.7,12.7,0,0,1-1.13,2.72,13.44,13.44,0,0,1-1.7,2.37A8.72,8.72,0,0,1,64.76,81a4.47,4.47,0,0,1-2.21.71,2.53,2.53,0,0,1-1.66-.59,3.72,3.72,0,0,1-1.06-1.68,9.48,9.48,0,0,1-.42-2.53q0-1.07,0-2.31t0-2.4a13.78,13.78,0,0,1,.41-3,14.74,14.74,0,0,1,1.06-2.9,12.28,12.28,0,0,1,1.66-2.51,8.62,8.62,0,0,1,2.22-1.85,4.69,4.69,0,0,1,2.11-.7,2.84,2.84,0,0,1,1.7.41,3,3,0,0,1,1.13,1.41,5.85,5.85,0,0,1,.43,2.29,1.2,1.2,0,0,1-.11.48.71.71,0,0,1-.27.33l-2.25,1.3c-.2.11-.33.13-.4.05a1.13,1.13,0,0,1-.19-.48,3.56,3.56,0,0,0-.19-.58,1.07,1.07,0,0,0-.37-.46,1.08,1.08,0,0,0-.62-.16,2.16,2.16,0,0,0-1,.35,3.54,3.54,0,0,0-1,.81,4.79,4.79,0,0,0-.65,1.06,5.41,5.41,0,0,0-.38,1.2A8.71,8.71,0,0,0,62.6,70.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.24,54.73a4.57,4.57,0,0,1,2-.67,2.83,2.83,0,0,1,1.59.34,2.57,2.57,0,0,1,1.05,1.09A3.52,3.52,0,0,1,82.3,57a1.2,1.2,0,0,1-.11.48.69.69,0,0,1-.25.31l-2.26,1.31a.61.61,0,0,1-.39.11.67.67,0,0,1-.3-.14l-.16-.17a.77.77,0,0,0-.32-.2,1.2,1.2,0,0,0-.52,0,2.06,2.06,0,0,0-.75.29,5.39,5.39,0,0,0-.63.43,3.74,3.74,0,0,0-.53.52,2.52,2.52,0,0,0-.38.63,1.86,1.86,0,0,0-.15.75.83.83,0,0,0,.17.57.74.74,0,0,0,.55.17,4.33,4.33,0,0,0,1-.16l1.58-.41a5.17,5.17,0,0,1,1.65-.21,1.94,1.94,0,0,1,1.18.45,2.41,2.41,0,0,1,.71,1.18,7.43,7.43,0,0,1,.23,2,9,9,0,0,1-.39,2.64A11.32,11.32,0,0,1,81.14,70a10.86,10.86,0,0,1-1.69,2.12,10.39,10.39,0,0,1-2.13,1.63,5.16,5.16,0,0,1-2.13.75,2.79,2.79,0,0,1-1.66-.3,2.54,2.54,0,0,1-1.09-1.13A3.85,3.85,0,0,1,72,71.34a1.07,1.07,0,0,1,.12-.48.65.65,0,0,1,.25-.32l2.25-1.3a.7.7,0,0,1,.38-.12.54.54,0,0,1,.27.12,2.39,2.39,0,0,1,.21.22,1.2,1.2,0,0,0,.37.28,1.14,1.14,0,0,0,.58.1,2,2,0,0,0,.87-.32,6.46,6.46,0,0,0,1.53-1.18,2.14,2.14,0,0,0,.61-1.46.57.57,0,0,0-.23-.53,1.17,1.17,0,0,0-.67-.1,6.55,6.55,0,0,0-1.14.22c-.47.13-1,.27-1.64.42a2.48,2.48,0,0,1-2.59-.45,4.7,4.7,0,0,1-.82-3.17,9.14,9.14,0,0,1,.33-2.37,11.14,11.14,0,0,1,1-2.39,10.37,10.37,0,0,1,1.54-2.14A8.55,8.55,0,0,1,77.24,54.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,47.54a4.56,4.56,0,0,1,2-.68,3,3,0,0,1,1.59.34,2.69,2.69,0,0,1,1,1.09,3.56,3.56,0,0,1,.4,1.55,1.07,1.07,0,0,1-.12.48.62.62,0,0,1-.25.31l-2.25,1.3a.63.63,0,0,1-.39.12.62.62,0,0,1-.3-.14l-.16-.17a.84.84,0,0,0-.32-.2,1.06,1.06,0,0,0-.52,0,2,2,0,0,0-.75.29,5.39,5.39,0,0,0-.63.43,3.8,3.8,0,0,0-.54.52,2.48,2.48,0,0,0-.37.63,1.86,1.86,0,0,0-.15.75.78.78,0,0,0,.16.56.73.73,0,0,0,.55.18,4.32,4.32,0,0,0,1-.16l1.58-.41A5.17,5.17,0,0,1,93,54.07a2,2,0,0,1,1.18.44,2.45,2.45,0,0,1,.71,1.19,7.43,7.43,0,0,1,.23,2,8.76,8.76,0,0,1-.4,2.64,10.44,10.44,0,0,1-1.11,2.46,11,11,0,0,1-1.68,2.12,10.76,10.76,0,0,1-2.13,1.63,5.16,5.16,0,0,1-2.13.75A3,3,0,0,1,86,67a2.59,2.59,0,0,1-1.09-1.13,3.74,3.74,0,0,1-.42-1.75,1,1,0,0,1,.12-.47.65.65,0,0,1,.24-.32l2.26-1.3a.85.85,0,0,1,.38-.13.54.54,0,0,1,.27.12,2.88,2.88,0,0,1,.21.23,1.08,1.08,0,0,0,.37.27,1,1,0,0,0,.58.1,2,2,0,0,0,.87-.31,6.49,6.49,0,0,0,1.53-1.19,2.1,2.1,0,0,0,.61-1.45.57.57,0,0,0-.23-.53,1.09,1.09,0,0,0-.67-.1,5.72,5.72,0,0,0-1.14.22q-.7.19-1.65.42a2.51,2.51,0,0,1-2.59-.45,4.78,4.78,0,0,1-.81-3.17,9.14,9.14,0,0,1,.33-2.37,11.14,11.14,0,0,1,1-2.39,10.71,10.71,0,0,1,1.54-2.15A8.51,8.51,0,0,1,89.7,47.54Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,89.72l-53.89,31a3,3,0,0,0-1.34,2.32v30.08a2.92,2.92,0,0,0,1.34,2.3l5.32,3a3,3,0,0,0,2.68,0l53.89-31a3,3,0,0,0,1.34-2.32V95a2.92,2.92,0,0,0-1.34-2.3l-5.32-3A3,3,0,0,0,96.5,89.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,94.79c-.1-.67-.65-.91-1.32-.53l-53.88,31a2.77,2.77,0,0,0-.95,1l-8-4.59a2.63,2.63,0,0,1,.92-.95l53.89-31a3,3,0,0,1,2.68,0l5.32,3A2.92,2.92,0,0,1,105.82,94.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,94.26l-53.89,31a3,3,0,0,0-1.33,2.32V157.7c0,.85.6,1.2,1.33.77l53.89-31a3,3,0,0,0,1.34-2.32V95C105.84,94.18,105.24,93.83,104.5,94.26Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,125.82a.25.25,0,0,1,.33,0,.58.58,0,0,1,.14.43v17.11a1.37,1.37,0,0,1-.14.58.8.8,0,0,1-.33.4l-2.25,1.3a.24.24,0,0,1-.33,0,.57.57,0,0,1-.14-.42v-6.49l-3.82,2.2v6.49a1.4,1.4,0,0,1-.13.59,1,1,0,0,1-.33.4l-2.25,1.3a.27.27,0,0,1-.33,0,.58.58,0,0,1-.14-.44V132.15a1.42,1.42,0,0,1,.14-.59.9.9,0,0,1,.33-.4l2.25-1.3a.26.26,0,0,1,.33,0,.56.56,0,0,1,.13.42v6.38l3.82-2.2V128.1a1.41,1.41,0,0,1,.14-.58.85.85,0,0,1,.33-.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43,118.56a.24.24,0,0,1,.33,0,.57.57,0,0,1,.14.42v2.81a1.34,1.34,0,0,1-.14.58.88.88,0,0,1-.33.41l-3,1.74v13.59a1.4,1.4,0,0,1-.13.59,1.05,1.05,0,0,1-.33.4l-2.25,1.3a.27.27,0,0,1-.33,0,.58.58,0,0,1-.14-.43V126.38l-3,1.75a.26.26,0,0,1-.33,0,.58.58,0,0,1-.13-.43v-2.8a1.4,1.4,0,0,1,.13-.59.91.91,0,0,1,.33-.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,127.86a1.13,1.13,0,0,1-.24-.3l-1.61-3.44v8.77a1.37,1.37,0,0,1-.14.58.8.8,0,0,1-.33.4l-2.25,1.3a.24.24,0,0,1-.33,0,.57.57,0,0,1-.14-.42V117.61a1.37,1.37,0,0,1,.14-.58.85.85,0,0,1,.33-.4l2-1.15c.22-.14.4-.14.51,0a1.71,1.71,0,0,1,.23.3l2.78,5.72,2.79-8.94a5.88,5.88,0,0,1,.22-.56,1.3,1.3,0,0,1,.52-.59l2-1.15a.25.25,0,0,1,.32,0,.58.58,0,0,1,.14.43v17.11a1.42,1.42,0,0,1-.14.59,1,1,0,0,1-.32.4l-2.26,1.3a.26.26,0,0,1-.33,0,.54.54,0,0,1-.13-.42v-8.77l-1.62,5.31a5.67,5.67,0,0,1-.23.57,1,1,0,0,1-.41.46l-1.1.63C83.57,128,83.44,128,83.34,127.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,117.53a.25.25,0,0,1,.33,0,.56.56,0,0,1,.14.42v2.81a1.37,1.37,0,0,1-.14.58.8.8,0,0,1-.33.4l-8,4.6a.25.25,0,0,1-.33,0,.57.57,0,0,1-.14-.42V108.81a1.37,1.37,0,0,1,.14-.58.8.8,0,0,1,.33-.4l2.25-1.3a.24.24,0,0,1,.33,0,.57.57,0,0,1,.13.42v13.59Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,152.23,42.61,183.28a2.94,2.94,0,0,0-1.34,2.31v30.08a2.89,2.89,0,0,0,1.34,2.3l5.32,3a3,3,0,0,0,2.68,0l53.89-31.05a2.94,2.94,0,0,0,1.34-2.31V157.55a2.92,2.92,0,0,0-1.34-2.31l-5.32-3A3,3,0,0,0,96.5,152.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,157.3c-.1-.67-.65-.91-1.32-.53l-53.88,31a2.7,2.7,0,0,0-.95,1l-8-4.59a2.66,2.66,0,0,1,.92-1l53.89-31a3,3,0,0,1,2.68,0l5.32,3A2.94,2.94,0,0,1,105.82,157.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,156.77l-53.89,31a3,3,0,0,0-1.33,2.31v30.08c0,.86.6,1.2,1.33.78l53.89-31.05a2.94,2.94,0,0,0,1.34-2.31V157.55C105.84,156.69,105.24,156.35,104.5,156.77Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,194.92c0,.24,0,.56,0,1s0,.83,0,1.26,0,.86,0,1.27,0,.73,0,1a6.49,6.49,0,0,0,.16,1.08,1.7,1.7,0,0,0,.38.76,1,1,0,0,0,.65.3,1.86,1.86,0,0,0,1-.32,4,4,0,0,0,1-.76,5.44,5.44,0,0,0,.62-.88,4.53,4.53,0,0,0,.37-.89,8.22,8.22,0,0,0,.19-.8,3.45,3.45,0,0,1,.19-.71,1,1,0,0,1,.4-.4l2.25-1.3a.21.21,0,0,1,.27,0,.49.49,0,0,1,.11.35,10.35,10.35,0,0,1-.43,2.79,12.24,12.24,0,0,1-1.14,2.72,12.9,12.9,0,0,1-1.69,2.37,8.49,8.49,0,0,1-2.11,1.73,4.37,4.37,0,0,1-2.21.71,2.53,2.53,0,0,1-1.66-.59,3.72,3.72,0,0,1-1.06-1.68,9.41,9.41,0,0,1-.42-2.53q0-1.07,0-2.31t0-2.4a13.78,13.78,0,0,1,.41-3,14.74,14.74,0,0,1,1.06-2.9,12.28,12.28,0,0,1,1.66-2.51,8.82,8.82,0,0,1,2.22-1.85,4.69,4.69,0,0,1,2.11-.7,2.86,2.86,0,0,1,1.69.41,3,3,0,0,1,1.14,1.41,5.86,5.86,0,0,1,.43,2.3,1.19,1.19,0,0,1-.11.47.71.71,0,0,1-.27.33l-2.25,1.3c-.2.11-.33.13-.4.06a1.25,1.25,0,0,1-.19-.49,3.56,3.56,0,0,0-.19-.58,1.13,1.13,0,0,0-.37-.46,1.1,1.1,0,0,0-.62-.16,2.16,2.16,0,0,0-1,.35,3.54,3.54,0,0,0-1,.81,5,5,0,0,0-.65,1.06,5.41,5.41,0,0,0-.38,1.2A10.42,10.42,0,0,0,63.64,194.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.44,191.39v4.37a1.42,1.42,0,0,1-.14.59,1,1,0,0,1-.32.4L76.81,198a.27.27,0,0,1-.33,0,.58.58,0,0,1-.14-.43v-4.37l-2.66,1.54a.25.25,0,0,1-.33,0,.58.58,0,0,1-.14-.43V191.6a1.34,1.34,0,0,1,.14-.58.88.88,0,0,1,.33-.41l2.66-1.54V184.7a1.37,1.37,0,0,1,.14-.58.85.85,0,0,1,.33-.4L79,182.47a.24.24,0,0,1,.32,0,.57.57,0,0,1,.14.42v4.38l2.65-1.53a.24.24,0,0,1,.33,0,.57.57,0,0,1,.14.42v2.68a1.37,1.37,0,0,1-.14.58.8.8,0,0,1-.33.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,184.81v4.37a1.41,1.41,0,0,1-.14.58.85.85,0,0,1-.33.4l-2.16,1.25a.25.25,0,0,1-.33,0,.57.57,0,0,1-.14-.42v-4.38l-2.67,1.54a.23.23,0,0,1-.32,0,.57.57,0,0,1-.14-.42V185a1.37,1.37,0,0,1,.14-.58.84.84,0,0,1,.32-.4l2.67-1.54v-4.37a1.42,1.42,0,0,1,.14-.59.9.9,0,0,1,.33-.4l2.16-1.25a.27.27,0,0,1,.33,0,.58.58,0,0,1,.14.43v4.37l2.65-1.53a.26.26,0,0,1,.33,0,.58.58,0,0,1,.13.43v2.67a1.33,1.33,0,0,1-.13.58.86.86,0,0,1-.33.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutmeImg);
export default __webpack_public_path__ + "static/media/aboutmeIMG.c76143fc1960c9d67c4c3534c3f91ac7.svg";
export { ForwardRef as ReactComponent };